import axios from "axios";
import config from "@/config";

let clientInstance: ReturnType<typeof axios.create> | null = null;

export const strapiClient = () => {
    // Sigleton Pattern
    if (clientInstance) {
        return clientInstance;
    }

    const client = axios.create();

    client.interceptors.request.use((req) => {
        req.baseURL = config.STRAPI_API_URL;
        req.headers = {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
        return req;
    })

    clientInstance = client;
    return client;
}